import React from 'react';
import Hero from '../components/Hero';
import Introduction from '../components/Introduction';
import Services from '../components/Services';
import GeneralInfo from '../components/GeneralInfo';
import Reviews from '../components/Reviews';
import DemoLessonForm from '../components/DemoLessonForm';
import Reveal from '../components/Reveal';

const Home: React.FC = () => {
  return (
    <>
      <Hero />
      <Reveal as="section" delayMs={80}>
        <Introduction />
      </Reveal>
      <Reveal as="section" delayMs={120}>
        <Services />
      </Reveal>
      <Reveal as="section" delayMs={160}>
        <GeneralInfo />
      </Reveal>
      <Reveal as="section" delayMs={200}>
        <Reviews />
      </Reveal>
      <Reveal as="section" delayMs={240}>
        <DemoLessonForm />
      </Reveal>
    </>
  );
};

export default Home;